import { createStyles } from '@mantine/core';

export const useStyles = createStyles((theme) => ({
	removeBorder: {
		// MarkdownRenderer overrides
		'& h1': {
			borderBottom: 'none !important',
			marginBottom: `0px !important`,
		},
	},
	relatedResourceGroup: {
		cursor: 'pointer',
		flexWrap: 'nowrap',
		width: '100%',
		backgroundColor: theme.other.getColor('surface/primary/default'),
		boxShadow: theme.shadows.sm,
		borderRadius: theme.radius.md,
		padding: theme.spacing.sm,
		gap: theme.spacing.sm,
		'&:hover': {
			backgroundColor: theme.other.getColor('surface/primary/hover'),
		},
		'&:active': {
			backgroundColor: theme.other.getColor('surface/primary/active'),
		},
	},
}));
